import React, { useEffect, useState } from 'react';
import { useListContext } from '@assets/spa/context/list';
import lt from "date-fns/locale/lt";
import qEvents from '@assets/gql/events.gql';
import qEventsAttributes from "@assets/gql/events.attributes.gql";
import qEventdates from "@assets/gql/events.dates.gql";
import { useQuery } from '@apollo/client';
import client from '@gql/client';
import { LoadingBox } from '@assets/tsx/loadingBox/loadingBox';
import Image from '@assets/tsx/image';
import { Link } from '@ambiguous/link';
import placeholder from './placeholder.jpg';
import { PaginatorButtons } from '@assets/tsx/paginator/buttons';
import { useLang } from '@ambiguous/useLang';
import { Filters } from '@assets/tsx/list';
import { useI18n } from '@wordpress/react-i18n';
import { Radio } from '@assets/spa/control/radio';
// import { Radio } from '@assets/tsx/radio';
import ReactDatePicker from 'react-datepicker';
import { ControlWrap } from '@assets/spa/control/wrap';
import SidebarModal, { SidebarControllers } from '@assets/tsx/sidebarModal/SidebarModal';
import OutsideAlerter from '@assets/tsx/outsideClicker';
import { useBreakpoint } from '@assets/tsx/useBreakpoint';
export default function Events({ _id, categories, pagination, perPage, title }) {
    var _a;
    const { __ } = useI18n();
    const [lists, setLists] = useListContext();
    const listData = lists ? (lists[_id] || {}) : {};
    const [language] = useLang();
    const { data: attrData } = useQuery(qEventsAttributes, {
        client,
        variables: { language: language.toUpperCase() }
    });
    const [page, setPage] = useState((_a = listData === null || listData === void 0 ? void 0 : listData.page) !== null && _a !== void 0 ? _a : 0);
    const [wrap, setWrap] = useState();
    const [checkedFilters, setCheckedFilters] = useState((listData === null || listData === void 0 ? void 0 : listData.checkedFilters) || []);
    const [filters, setFilters] = useState({});
    const [price, setPrice] = useState((listData === null || listData === void 0 ? void 0 : listData.price) || 'all');
    const [filtersArr, setFiltersArr] = useState([]);
    const [monthDate, setMonthDate] = useState((listData === null || listData === void 0 ? void 0 : listData.monthDate) || new Date(Date.now()));
    const [date, setDate] = useState(listData === null || listData === void 0 ? void 0 : listData.date);
    const [lang] = useLang();
    const [sidebarOpen, setSidebarOpen] = useState(false);
    useEffect(() => {
        if (!setLists)
            return;
        setLists((prev) => (Object.assign(Object.assign({}, prev), { [_id]: {
                page,
                checkedFilters,
                price,
                monthDate,
                date,
            } })));
    }, [
        page,
        checkedFilters,
        price,
        monthDate,
        date,
    ]);
    useEffect(() => {
        if (!attrData)
            return;
        const allAttributes = attrData.attributes.renginiai.reduce((agr, fGroup) => [...agr, ...fGroup.terms.nodes], []);
        const checkedArr = allAttributes.filter(f => checkedFilters.includes(f.databaseId));
        const filterMap = {};
        for (const attribute of checkedArr) {
            const { taxonomyEnumValue, databaseId } = attribute;
            if (!filterMap[taxonomyEnumValue]) {
                filterMap[taxonomyEnumValue] = [];
            }
            filterMap[taxonomyEnumValue].push(databaseId.toString());
        }
        const filterVar = Object.keys(filterMap).reduce((agr, fenum) => [...agr, { taxonomy: fenum, terms: filterMap[fenum], field: 'ID' }], []);
        setFiltersArr(filterVar);
    }, [checkedFilters, attrData]);
    const { items: events, loading, fetchMore, total, eventDates } = useEventItems(categories, perPage, page, setPage, filtersArr, price, date, monthDate);
    useEffect(() => {
        var _a;
        if (!attrData)
            return;
        const flat = (_a = attrData === null || attrData === void 0 ? void 0 : attrData.attributes) === null || _a === void 0 ? void 0 : _a.renginiai;
        // const hidden = attributes?.hidden || [];
        const labeled = flat === null || flat === void 0 ? void 0 : flat.reduce((agr, fGroup, sortOrder) => {
            var _a;
            const fEnum = fGroup.taxonomy.node.taxonomyEnumValue;
            const attributes = ((_a = fGroup === null || fGroup === void 0 ? void 0 : fGroup.terms) === null || _a === void 0 ? void 0 : _a.nodes) || [];
            // const count = attributes.reduce((agr,{count})=>agr + parseInt(count || '0'),0)
            // console.log({count,show_empty})
            // if(count === 0 && show_empty !== 'yes') return agr;
            // if(hidden.includes(fEnum)) return agr;
            return Object.assign(Object.assign({}, agr), { [fEnum]: {
                    label: fGroup.label,
                    attributes,
                    sortOrder,
                } });
        }, {});
        setFilters(labeled);
    }, [attrData]);
    useEffect(() => { setPage(0); }, [price, attrData]);
    const bp = useBreakpoint();
    return React.createElement("div", { className: "ltg-events" },
        React.createElement("div", { className: `ltg-events-content${pagination === 'yes' ? ' --filters-on' : ''} --${bp}` },
            pagination === 'yes' &&
                EventsFilters({
                    checkedFilters,
                    filters,
                    setCheckedFilters,
                    setPage,
                    date,
                    lang,
                    setDate,
                    eventDates,
                    setMonthDate,
                    monthDate,
                    price,
                    setPrice,
                    sidebarOpen,
                    setSidebarOpen,
                }),
            React.createElement("div", null,
                React.createElement("div", null,
                    React.createElement("div", { className: "ltg-events-head" },
                        React.createElement("div", { className: 'ltg-events-head-text' },
                            React.createElement("h2", { className: "ltg-events-title" }, title || __("Renginiai", 'ltg-widgets')),
                            date ? React.createElement("div", { className: "ltg-events-date" },
                                dateStr(date),
                                React.createElement("button", { onClick: () => { setDate(undefined); } },
                                    React.createElement("span", { className: "sr-only" }, __('Išvalyti', 'ltg-widgets')),
                                    React.createElement("i", { className: "fas fa-times" }))) :
                                React.createElement("h4", null,
                                    React.createElement("b", null, __('Artimiausi', 'ltg-widgets')))),
                        bp !== 'desktop' && React.createElement("div", null,
                            React.createElement("button", { className: 'btn btn-white btn-sm btn-outlined', onClick: () => { setSidebarOpen(true); } },
                                React.createElement("span", { className: "sr-only" }, __('Filtrai', 'ltg-widgets')),
                                React.createElement("i", { className: "fas fa-filter text-primary" }))))),
                React.createElement("div", { className: "ltg-posts-list", ref: setWrap },
                    loading && new Array(Number(perPage) || 3).fill('').map((_, index) => {
                        return React.createElement(LoadingBox, { key: `events-loader-${index}`, style: { paddingBottom: '56.25%' } });
                    }),
                    events && events.map((props) => {
                        return React.createElement(EventCard, Object.assign({ key: props.id }, props));
                    })),
                !loading && !(events === null || events === void 0 ? void 0 : events.length) && React.createElement(React.Fragment, null,
                    React.createElement("h2", { className: "text-center" }, __('Renginių nėra', 'ltg-widgets'))),
                ((pagination === 'yes') && +total > 1) && (React.createElement("div", { className: "ltg-posts-paginator-wrap" },
                    React.createElement(PaginatorButtons, { total: total, 
                        // key={activeCategory || 'all'} 
                        page: page, onClick: (clickedPage) => {
                            fetchMore(clickedPage).then(() => {
                                wrap && wrap.scrollIntoView({ behavior: 'smooth' });
                            });
                        } }))))));
}
function EventsFilters({ checkedFilters, filters, setCheckedFilters, setPage, date, lang, setDate, eventDates, setMonthDate, monthDate, price, setPrice, setSidebarOpen, sidebarOpen }) {
    const { __ } = useI18n();
    const isToday = monthDate.toISOString().substring(0, 7) === new Date(Date.now()).toISOString().substring(0, 7);
    const pricings = [
        [__('Visi', 'ltg-widgets'), 'all'],
        [__('Nemokamas', 'ltg-widgets'), 'free'],
        [__('Mokamas', 'ltg-widgets'), 'paid'],
    ];
    const onClearFilters = () => {
        setSidebarOpen(false);
        setCheckedFilters([]);
        setPrice('all');
        setDate(undefined);
    };
    const bp = useBreakpoint();
    const filtersContent = React.createElement(Filters, Object.assign({}, { checkedFilters, filters, setCheckedFilters, setPage }),
        React.createElement(ControlWrap, null,
            React.createElement(ReactDatePicker, { selected: date, locale: lang === "lt" ? lt : undefined, dateFormat: 'yyyy-MM-dd', timeFormat: 'HH:mm', wrapperClassName: 'd-block', className: 'ltg-control d-block', onChange: (new_date) => {
                    setDate(new_date);
                }, todayButton: !isToday ? __('Šiandien', 'ltg-widgets') : undefined, highlightDates: eventDates, onMonthChange: (date) => {
                    // setDate(undefined);
                    setMonthDate(date);
                }, inline: true, showIcon: true, calendarStartDay: lang === 'lt' ? 1 : undefined })),
        React.createElement("h4", null, __('Kaina', 'ltg-widgets')),
        pricings.map(([label, value]) => {
            return React.createElement(Radio, { key: value, 
                // id={"events-filters-radio-" + value}
                label: label, checked: value === price, onChange: () => { setPrice(value); } });
        }));
    if (bp !== 'desktop')
        return React.createElement("div", { className: "ltg-events-filters text-right" },
            React.createElement(SidebarModal, { open: sidebarOpen },
                React.createElement(OutsideAlerter, { className: 'ltg-modal-sidebar-wrap', callback: () => {
                        setSidebarOpen(false);
                    } },
                    React.createElement(SidebarControllers, { handleClearFilters: onClearFilters, handleCloseMenu: () => { setSidebarOpen(false); }, isFilters: true }),
                    filtersContent)));
    return filtersContent;
}
function EventCard({ renginiaiFields, featuredImage, title, uri }) {
    var _a, _b;
    const dateObj = new Date(renginiaiFields.date);
    const [lang] = useLang();
    let dateStr = dateObj.toLocaleDateString(lang, { month: 'long', day: 'numeric' });
    dateStr = dateStr[0].toUpperCase() + dateStr.substring(1);
    const time = renginiaiFields.time.substring(0, 5);
    return React.createElement("div", { className: "ltg-events-card" },
        React.createElement(Link, { href: uri, className: "ltg-events-card-img-wrap" },
            React.createElement(Image, { src: ((_a = featuredImage === null || featuredImage === void 0 ? void 0 : featuredImage.node) === null || _a === void 0 ? void 0 : _a.sourceUrl) || placeholder, alt: ((_b = featuredImage === null || featuredImage === void 0 ? void 0 : featuredImage.node) === null || _b === void 0 ? void 0 : _b.altText) || 'Nuotrauka', className: 'ltg-events-card-img' })),
        React.createElement("div", { className: "ltg-events-card-data" },
            React.createElement("div", { className: "ltg-events-card-date" },
                dateStr,
                ", ",
                time),
            React.createElement(Link, { href: uri, className: "ltg-events-card-link" }, title)));
}
function useEventItems(activeCategory, perPage, page, setPage, filters, price, date, monthDate) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    let taxArray = filters || [];
    const metaArray = [];
    // const orderby = {field: "META_KEY", metaDataType: "DATE", metaKeyField: "date", order: "ASC"};
    const year_month = dateStr(monthDate).substring(0, 7);
    const last_day = new Date(monthDate.getFullYear(), monthDate.getMonth() + 1, 0).getDate();
    const monthMetaArray = [
        { compare: "GREATER_THAN_OR_EQUAL_TO", key: "date", type: "DATE", value: `${year_month}-01` },
        { compare: "LESS_THAN_OR_EQUAL_TO", key: "date", type: "DATE", value: `${year_month}-${last_day}` },
    ];
    if (date) {
        const value = dateStr(date);
        metaArray.push({ compare: "EQUAL_TO", key: "date", type: "DATE", value });
    }
    else {
        metaArray.push({ compare: "GREATER_THAN_OR_EQUAL_TO", key: "date", type: "DATE", value: dateStr(new Date(Date.now())) });
    }
    if ((activeCategory === null || activeCategory === void 0 ? void 0 : activeCategory.length) > 0) {
        taxArray = [
            ...filters,
            {
                field: 'TAXONOMY_ID',
                operator: 'IN',
                taxonomy: 'RENGINIUKATEGORIJA',
                terms: activeCategory
            }
        ];
    }
    const [language] = useLang();
    if (price === 'free') {
        metaArray.push({ key: "is_paid", compare: 'EQUAL_TO', value: '0' });
    }
    else if (price === 'paid') {
        metaArray.push({ key: "is_paid", compare: 'EQUAL_TO', value: '1' });
    }
    const { data, loading, refetch } = useQuery(qEvents, {
        client,
        variables: {
            offset: page * perPage,
            perPage,
            taxArray: taxArray.length > 0 ? taxArray : undefined,
            language: (language === null || language === void 0 ? void 0 : language.toUpperCase()) || 'DEFAULT',
            metaArray,
            // orderby
        }
    });
    const { data: monthData } = useQuery(qEventdates, {
        client,
        variables: {
            taxArray: taxArray.length > 0 ? taxArray : undefined,
            language: (language === null || language === void 0 ? void 0 : language.toUpperCase()) || 'DEFAULT',
            metaArray,
            year: `${monthDate.getFullYear()}`,
        }
    });
    const items = ((_b = (_a = data === null || data === void 0 ? void 0 : data.renginiai) === null || _a === void 0 ? void 0 : _a.edges) === null || _b === void 0 ? void 0 : _b.map(edge => edge.node)) || [];
    const hasMore = ((_e = (_d = (_c = data === null || data === void 0 ? void 0 : data.renginiai) === null || _c === void 0 ? void 0 : _c.pageInfo) === null || _d === void 0 ? void 0 : _d.offsetPagination) === null || _e === void 0 ? void 0 : _e.hasMore) || false;
    const total = Math.ceil(((_h = (_g = (_f = data === null || data === void 0 ? void 0 : data.renginiai) === null || _f === void 0 ? void 0 : _f.pageInfo) === null || _g === void 0 ? void 0 : _g.offsetPagination) === null || _h === void 0 ? void 0 : _h.total) / perPage) || 0;
    const eventDates = (_j = monthData === null || monthData === void 0 ? void 0 : monthData.renginiaiUniqueDates) === null || _j === void 0 ? void 0 : _j.map((date) => new Date(date));
    const fetchMoreItems = (page) => new Promise((res, rej) => {
        setPage(page);
        refetch({
            perPage,
            taxArray,
            offset: page * perPage,
            language: (language === null || language === void 0 ? void 0 : language.toUpperCase()) || 'DEFAULT',
            metaArray,
            // orderby
        }).then(res).catch(err => { rej(err); });
    });
    return {
        items,
        loading,
        hasMore,
        total,
        fetchMore: fetchMoreItems,
        eventDates
    };
}
function dateStr(date) {
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const value = `${date.getFullYear()}-${month}-${day}`;
    return value;
}
